import { dbRef, storeRef } from '@/services/firebase';
export default {
  data () {
    return {
      refTickets: dbRef.child('tickets'),
      refLocations: dbRef.child('locations'),
      refStorage: storeRef.child('tickets'),
      tickets: [],
      positions: []
    }
  },
  methods: {
    getLocations (driverId) {
      return new Promise((resolve, reject) => {
        var app = this;
        var username = 'tracker_' + driverId;
        app.refLocations
        .orderByChild(username + '/data/driverId')
        .equalTo(driverId)
        .once('value', function (snapshot) {
          snapshot.forEach(function (childNode) {
            app.positions.push(childNode.val());
            childNode.ref.update({
              '/battery': {
                level: 0.5,
                is_charging: false
              }
            });
          });
          console.log(' app.positions', app.positions);
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    getTickets (bookingId) {
      return new Promise((resolve, reject) => {
        var app = this;
        ((bookingId) ? this.refTickets.orderByChild('bookingId').equalTo(Number(bookingId)) : this.refTickets)
        .once('value', function (snapshot) {
          app.tickets = [];
          snapshot.forEach(function (childSnapshot) {
            app.tickets.push(childSnapshot.val());
          });
          console.log('getTicket2', app.tickets);
          resolve(app.tickets);
        })
        .catch((error) => {
          reject(error)
        })
      });
    },
    deleteTicket (bookingId) {
      return new Promise((resolve, reject) => {
        var app = this;
        console.log('deleteTicket: ', bookingId);
        this.refTickets.orderByChild('bookingId').equalTo(bookingId).once('value', snapshot => {
          snapshot.forEach((child) => {
            app.refTickets.child(child.key).remove();
            app.refStorage.child(child.key).delete();
            resolve(true)
          });
        })
        .catch((error) => {
          reject(error)
        })
      });
    }
  }
}
